"use strict";

var isIterable = require("./is-iterable");

module.exports = function (value) {
	if (!isIterable(value)) throw new TypeError(value + " is not iterable");
	return value;
};



//////////////////
// WEBPACK FOOTER
// /Users/Fuunnx/workspace/zygmund/~/es6-iterator/valid-iterable.js
// module id = ../../../node_modules/es6-iterator/valid-iterable.js
// module chunks = 1